/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface PaypayPaymentRedirectRequest {
    redirectUrl: string;
}

/**
 * 
 */
export class ExternalConnectPayPayApi extends runtime.BaseAPI {

    /**
     * PayPay決済完了後、PayPayから実行されるAPIです。パラメータで受け取ったURLへリダイレクトします。 
     * PayPay決済リダイレクト
     */
    async paypayPaymentRedirectRaw(requestParameters: PaypayPaymentRedirectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.redirectUrl === null || requestParameters.redirectUrl === undefined) {
            throw new runtime.RequiredError('redirectUrl','Required parameter requestParameters.redirectUrl was null or undefined when calling paypayPaymentRedirect.');
        }

        const queryParameters: any = {};

        if (requestParameters.redirectUrl !== undefined) {
            queryParameters['redirectUrl'] = requestParameters.redirectUrl;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/connect/paypay/paypayPayment/redirect`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * PayPay決済完了後、PayPayから実行されるAPIです。パラメータで受け取ったURLへリダイレクトします。 
     * PayPay決済リダイレクト
     */
    async paypayPaymentRedirect(requestParameters: PaypayPaymentRedirectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.paypayPaymentRedirectRaw(requestParameters, initOverrides);
    }

}
